/**
 * @generated SignedSource<<03b5bc8532804bf6999e42c79c6301ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SummaryItemType = "action_item" | "bullet" | "decision";
export type ContextPopoverGenerateSummaryItemContextMutation$variables = {
  index: string;
  itemType: SummaryItemType;
  meetingRecordingId: string;
};
export type ContextPopoverGenerateSummaryItemContextMutation$data = {
  readonly generateSummaryItemContext: {
    readonly context: string;
  } | null;
};
export type ContextPopoverGenerateSummaryItemContextMutation = {
  response: ContextPopoverGenerateSummaryItemContextMutation$data;
  variables: ContextPopoverGenerateSummaryItemContextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "index"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingRecordingId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "index",
        "variableName": "index"
      },
      {
        "kind": "Variable",
        "name": "itemType",
        "variableName": "itemType"
      },
      {
        "kind": "Variable",
        "name": "meetingRecordingId",
        "variableName": "meetingRecordingId"
      }
    ],
    "concreteType": "GenerateSummaryItemContext",
    "kind": "LinkedField",
    "name": "generateSummaryItemContext",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "context",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContextPopoverGenerateSummaryItemContextMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContextPopoverGenerateSummaryItemContextMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1298c09c7489bbee7af30b2202fcd95c",
    "id": null,
    "metadata": {},
    "name": "ContextPopoverGenerateSummaryItemContextMutation",
    "operationKind": "mutation",
    "text": "mutation ContextPopoverGenerateSummaryItemContextMutation(\n  $meetingRecordingId: ID!\n  $itemType: SummaryItemType!\n  $index: String!\n) {\n  generateSummaryItemContext(meetingRecordingId: $meetingRecordingId, itemType: $itemType, index: $index) {\n    context\n  }\n}\n"
  }
};
})();

(node as any).hash = "f70cd89384aaa8e1fe4dd30a002495ef";

export default node;
